import type { AppRouter } from '@otryad/api';
import { QueryClient } from '@tanstack/react-query';
import { retrieveRawInitData } from '@telegram-apps/sdk-react';
import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';

export const trpc = createTRPCReact<AppRouter>();

export const apiUrl = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000').replace(/\/$/, '');

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: 1, staleTime: 10_000, refetchOnWindowFocus: false },
    },
  });
}

/** `Authorization: tma <initData>` — проверяется сервером на каждый запрос (ADR-5). */
export function authHeaders(): Record<string, string> {
  try {
    const raw = retrieveRawInitData();
    return raw ? { Authorization: `tma ${raw}` } : {};
  } catch {
    return {};
  }
}

export function createTrpcClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${apiUrl}/trpc`,
        headers: authHeaders,
      }),
    ],
  });
}
